export const apiKeyDetails = [
  {
    checkbox: true,
    service_name: "Paytm",
    image_url:"assets/img/users/user-32.jpg",
    created_by:"Anthony Lewis",
    api_key: "paytm1234567890abcdef",
    status: "Success",
    created_date:"14/01/2024",
    key: "1"
  },
  {
    checkbox: true,
    service_name: "Paytm",
    image_url:"assets/img/users/user-09.jpg",
    created_by:"Brian Villalobos",
    api_key: "paytm1234567890abcdef",
    status: "Rejected",
    created_date:"21/01/2024",
    key: "2"
  },
  {
    checkbox: true,
    service_name: "Paytm",
    image_url:"assets/img/users/user-01.jpg",
    created_by:"Harvey Smith",
    api_key: "paytm1234567890abcdef",
    status: "Success",
    created_date:"20/02/2024",
    key: "3"
  },
  {
    checkbox: true,
    service_name: "Paytm",
    image_url:"assets/img/users/user-33.jpg",
    created_by:"Stephan Peralt",
    api_key: "paytm1234567890abcdef",
    status: "Success",
    created_date:"15/03/2024",
    key: "4"
  },
  {
    checkbox: true,
    service_name: "Paytm",
    image_url:"assets/img/users/user-34.jpg",
    created_by:"Doglas Martini",
    api_key: "paytm1234567890abcdef",
    status: "Warning",
    created_date:"12/04/2024",
    key: "5"
  },
  {
    checkbox: true,
    service_name: "Paytm",
    image_url:"assets/img/users/user-02.jpg",
    created_by:"Linda Ray",
    api_key: "paytm1234567890abcdef",
    status: "Success",
    created_date:"20/05/2024",
    key: "6"
  },
  {
    checkbox: true,
    service_name: "Paytm",
    image_url:"assets/img/users/user-35.jpg",
    created_by:"Elliot Murray",
    api_key: "paytm1234567890abcdef",
    status: "Warning",
    created_date:"06/07/2024",
    key: "7"
  },
  {
    checkbox: true,
    service_name: "Paytm",
    image_url:"assets/img/users/user-36.jpg",
    created_by:"Rebecca Smtih",
    api_key: "paytm1234567890abcdef",
    status: "Rejected",
    created_date:"02/09/2024",
    key: "8"
  },
  {
    checkbox: true,
    service_name: "Paytm",
    image_url:"assets/img/users/user-37.jpg",
    created_by:"Connie Waters",
    api_key: "paytm1234567890abcdef",
    status: "Success",
    created_date:"15/11/2024",
    key: "9"
  },
  {
    checkbox: true,
    service_name: "Paytm",
    image_url:"assets/img/users/user-38.jpg",
    created_by:"Lori Broaddus",
    api_key: "paytm1234567890abcdef",
    status: "Success",
    created_date:"10/12/2024",
    key: "10"
  },

];
